import { cdlDef } from '../../cdl'

export default cdlDef({ id: 'CDLEVENINGSTAR', label: 'Evening Star', lookback: 12, penetration: 0.3 })
